import React from 'react';
import { Route, Switch, SwitchProps, match } from 'react-router-dom';
import { FreeLeadGeneratorLanding } from './FreeLeadGeneratorLanding/FreeLeadGeneratorLanding';
import { FreeLeadGeneratorBuilder } from './FreeLeadGeneratorBuilder/FreeLeadGeneratorBuilder';
import { FreeLeadGeneratorCongratulations } from './FreeLeadGeneratorCongratulations/FreeLeadGeneratorCongratulations';

export const FreeLeadGeneratorSwitch = ({
  match,
}: SwitchProps & { match: match }) => {
  return (
    <Switch>
      <Route
        path={`${match.path}/start`}
        component={FreeLeadGeneratorBuilder}
      />
      <Route
        path={`${match.path}/congratulations`}
        render={() => (
          <FreeLeadGeneratorCongratulations category="free_lead_generator" />
        )}
      />
      <Route path="/" component={FreeLeadGeneratorLanding} />
    </Switch>
  );
};
